/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_Item_2_DetailInputs */

const en_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formerly the Horton Smith Award`)
};

const es_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes llamado Premio Horton Smith`)
};

const de_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Früher Horton Smith Award genannt`)
};

const zh_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原名 Horton Smith 奖`)
};

const ar_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كانت تُعرف سابقاً بجائزة Horton Smith`)
};

const fr_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anciennement appelé prix Horton Smith`)
};

const vi_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trước đây mang tên Giải thưởng Horton Smith`)
};

const sw_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapo awali iliitwa Tuzo ya Horton Smith`)
};

const th_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เดิมชื่อรางวัล Horton Smith`)
};

const bs_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranije pod nazivom Nagrada Horton Smith`)
};

const ja_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旧称：Horton Smith賞`)
};

const ko_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전 명칭: Horton Smith 상`)
};

const pt_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteriormente chamado Prêmio Horton Smith`)
};

const it_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Già denominato premio Horton Smith`)
};

const sv_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hette tidigare Horton Smith Award`)
};

const nl_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorheen Horton Smith Award genoemd`)
};

const da_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hed tidligere Horton Smith-prisen`)
};

const nb_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het tidligere Horton Smith Award`)
};

const fi_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiemmin nimeltään Horton Smith -palkinto`)
};

const pl_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wcześniej pod nazwą Nagroda Hortona Smitha`)
};

const ru_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранее называлась Horton Smith Award`)
};

const tr_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eski adıyla Horton Smith Ödülü`)
};

const hi_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले इसका नाम Horton Smith पुरस्कार था`)
};

const id_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelumnya bernama Penghargaan Horton Smith`)
};

const ms_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dahulunya dikenali sebagai Anugerah Horton Smith`)
};

const cs_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dříve nazývaná Cena Hortona Smithe`)
};

const el_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παλαιότερα ονομαζόταν βραβείο Horton Smith`)
};

const he_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בעבר נקרא פרס Horton Smith`)
};

const af_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorheen bekend as die Horton Smith-toekenning`)
};

const hu_about_content_honor_0_item_2_detail = /** @type {(inputs: About_Content_Honor_0_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korábbi neve: Horton Smith-díj`)
};

/**
* | output |
* | --- |
* | "Formerly the Horton Smith Award" |
*
* @param {About_Content_Honor_0_Item_2_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_item_2_detail = /** @type {((inputs?: About_Content_Honor_0_Item_2_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_Item_2_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_item_2_detail(inputs)
	if (locale === "de") return de_about_content_honor_0_item_2_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_0_item_2_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_0_item_2_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_0_item_2_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_0_item_2_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_0_item_2_detail(inputs)
	if (locale === "th") return th_about_content_honor_0_item_2_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_0_item_2_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_0_item_2_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_0_item_2_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_0_item_2_detail(inputs)
	if (locale === "it") return it_about_content_honor_0_item_2_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_0_item_2_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_0_item_2_detail(inputs)
	if (locale === "da") return da_about_content_honor_0_item_2_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_0_item_2_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_0_item_2_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_0_item_2_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_0_item_2_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_0_item_2_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_0_item_2_detail(inputs)
	if (locale === "id") return id_about_content_honor_0_item_2_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_0_item_2_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_0_item_2_detail(inputs)
	if (locale === "el") return el_about_content_honor_0_item_2_detail(inputs)
	if (locale === "he") return he_about_content_honor_0_item_2_detail(inputs)
	if (locale === "af") return af_about_content_honor_0_item_2_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_0_item_2_detail(inputs)
	return en_about_content_honor_0_item_2_detail(inputs)
});